export const LOCALE_COOKIE_ID = 'mc-locale';

export enum SUPPORTED_LANGUAGES {
  EN_US = 'en-US',
  EN_GB = 'en-GB',
  FR_FR = 'fr-FR',
  FR_CA = 'fr-CA',
  DE_DE = 'de-DE',
  ES_ES = 'es-ES',
  DA_DK = 'da-DK',
  HU_HU = 'hu-HU',
  IT_IT = 'it-IT',
  JA_JP = 'ja-JP',
  NB_NO = 'nb-NO',
  NL_NL = 'nl-NL',
  PL_PL = 'pl-PL',
  PT_PT = 'pt-PT',
  SV_SE = 'sv-SE',
  TH_TH = 'th-TH',
}

export const SUPPORTED_LANGUAGES_VALUES: string[] =
  Object.values(SUPPORTED_LANGUAGES);

export const LANGUAGES_MAP: Record<string, string> = {
  da: 'da-DK',
  de: 'de-DE',
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  hu: 'hu-HU',
  it: 'it-IT',
  ja: 'ja-JP',
  nb: 'nb-NO',
  nl: 'nl-NL',
  pl: 'pl-PL',
  pt: 'pt-PT',
  sv: 'sv-SE',
  th: 'th-TH',
};

export const MUL_COOKIE_ID = 'preferred_lang';
